import React, { useState } from 'react';
//import { useLocation } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';
import Navigation from './Navigation';
import { GitHubIcon } from './Icons';
import './Header.css';

interface HeaderProps {
  subtitle?: string;
  showNavigation?: boolean;
}

const Header: React.FC<HeaderProps> = ({ subtitle, showNavigation = true }) => {
  const [isHeaderExpanded, setIsHeaderExpanded] = useState(true);
  //const location = useLocation();
  //const isHomePage = location.pathname === '/';

  const toggleHeader = () => {
    setIsHeaderExpanded(!isHeaderExpanded);
  };

  return (
    <header>
      <div className="header-content">
        <div className="header-title-section">
          <a href="https://www.trustline.id" target="_blank" rel="noopener noreferrer" className="header-logo-link">
            <h1>
              trustline{subtitle && ` - ${subtitle}`}
            </h1>
          </a>
          <button onClick={toggleHeader} className="header-toggle-btn" aria-label="Toggle header">
            <span className="desktop-arrow">{isHeaderExpanded ? '◄' : '►'}</span>
            <span className="mobile-arrow">{isHeaderExpanded ? '▲' : '▼'}</span>
          </button>
        </div>
        <div className={`wallet-section ${isHeaderExpanded ? 'expanded' : 'collapsed'}`}>
          <a
            href="https://github.com/Trustline-id/"
            target="_blank"
            rel="noopener noreferrer"
            className="github-link"
            aria-label="GitHub"
          >
            <GitHubIcon size={30} />
          </a>
          <ThemeToggle />
        </div>
      </div>
      {showNavigation /*&& !isHomePage*/ && (
        <div className="header-navigation">
          <Navigation />
        </div>
      )}
    </header>
  );
};

export default Header;
